// extracted by mini-css-extract-plugin
export var label = "_ax-1";
export var reminder = "_ax-0";